(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    const announcementBar = document.querySelector('.block-announcement-bar');
    if (!announcementBar) return;

    const activate = () => {
      const dismissButton = announcementBar.querySelector('.announcement-bar__dismiss-button');
      if (!dismissButton) return;

      dismissButton.addEventListener('click', function() {
        dismissButton.disabled = true;

        gsap.to(announcementBar, {
          height: 0,
          opacity: 0,
          duration: 0.35,
          ease: "power2.out",
          onComplete: () => {
            announcementBar.remove();
          }
        });
      });

      announcementBar.removeEventListener('mouseenter', activate);
      announcementBar.removeEventListener('touchstart', activate);
    };

    announcementBar.addEventListener('mouseenter', activate, { once: true });
    announcementBar.addEventListener('touchstart', activate, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
